<template>
    <div class="page page--req" ref="page">
        <clp-dialog :show="this.bool.showDialog" tablet="white">
            <makc-alert
                v-show="this.str.dialogType === 'server_fail'"
                @closeDialog="this.bool.showDialog = false"
            >
            </makc-alert>
            <makc-alert
                v-show="this.str.dialogType === 'loader'"
                type="loader"
                title="Пожалуйста, подождите"
            >
            </makc-alert>
            <descr-alert
                v-show="this.str.dialogType === 'descr_error'"
                :show-back-btn="false"
                :descr="this.str.descrErrorText"
            >
            </descr-alert>
            <div v-show="this.str.dialogType === 'payment'" class="payment">
                <div class="payment__title text-b text-lger">
                    Выберите способ оплаты
                </div>
                <!-- <div class="payment__descr text-mid">Вы&nbsp;можете оплатить любым из&nbsp;указанных способов. Обращаем внимание, без оплаты договор не&nbsp;начнет действовать!</div> -->
                <div class="payment__controls">
                    <div class="payment__qr">
                        <div class="payment__qr-title">
                            Оплатить по&nbsp;QR-коду
                        </div>
                        <img
                            class="payment__qr-img"
                            src="@/create/assets/images/qr.png"
                            alt="qr.png"
                        />
                    </div>
                    <div class="payment__btns">
                        <button class="payment__btns-btn button button--makc">
                            Оплатить картой
                        </button>
                        <button
                            class="payment__btns-btn button button--makc button--makc-blue"
                        >
                            Оплатить СБП
                        </button>
                        <button
                            @click="this.bool.showDialog = false"
                            class="payment__btns-btn button button--makc button--makc-unfilled"
                        >
                            Назад
                        </button>
                    </div>
                </div>
            </div>
            <div v-show="this.str.dialogType === 'sms'" class="sms">
                <div class="sms__title text-b text-lger">
                    Введите код из СМС
                </div>
                <div class="sms__descr text-smer">
                    Для подтверждения указанной информации и подписания
                    дополнительного соглашения к полису страхования простой
                    электронной подписью, пожалуйста, введите код из СМС
                </div>
                <div class="sms__descr text-smer">
                    Вводя код из СМС вы подтверждаете согласие с заключением
                    дополнительного соглашения к полису страхования №{{
                        this.obj.data.policy_number
                    }}
                    о снижении стоимости полиса
                </div>
                <div class="sms__numbers">
                    <clp-numbers
                        page="reqs"
                        :msg="this.str.msgAlert"
                        @inserted="
                            ($event) => {
                                (this.str.numbers = $event),
                                    (this.bool.codeCheckSuccess = true);
                            }
                        "
                        @sendAgain="this.fetchCode"
                    >
                    </clp-numbers>
                </div>

                <div class="sms__btns">
                    <!-- <button
                        @click="this.bool.showDialog = false"
                        class="sms__btns-btn button button--makc button--makc-blue"
                    >
                        Назад
                    </button> -->
                    <button
                        @click="this.checkNumbers"
                        :disabled="!this.bool.codeCheckSuccess"
                        class="sms__btns-btn button button--makc button--makc-unfilled"
                    >
                        Подтвердить
                    </button>
                </div>
            </div>
            <div v-show="this.str.dialogType === 'success'" class="sms">
                <div class="sms__title text-b text-lger">
                    Соглашение сформировано
                </div>
                <div class="sms__descr text-smer">
                    Дополнительное соглашение сформировано и направлено на
                    указанную вами электронную почту.
                </div>
                <div class="sms__descr text-smer">
                    Сумма возврата поступит на указанные вами реквизиты не
                    позднее 7 рабочих дней.
                </div>
                <!-- <div class="sms__btns">
                    <button
                        @click="this.bool.showDialog = false"
                        class="sms__btns-btn button button--makc button--makc-blue"
                    >
                        Назад
                    </button>
                </div> -->
            </div>
        </clp-dialog>

        <div v-if="this.bool.showPageContent" class="container container--req" style="margin-top: 40px">
            <div class="content content--req">
                <!-- Уважаемый клиент! -->
                <div class="content__title text-center text-sb text-giant text-mob-med mb30">
                    {{ this.bool.agtAlreadySigned || this.bool.agtNotFound ? "Недействительная ссылка" : "Уважаемый клиент!" }}
                </div>
                <div v-if="this.bool.agtAlreadySigned || this.bool.agtNotFound" class="content__subtitle text-med text-mob-smer mb30 mob-mb20">
                    {{ this.bool.agtAlreadySigned ? "По данному договору заявление уже заполнено и подписано" : "По данному запросу заявление к договору не найдено" }} 
                </div>
                <div v-else class="content__subtitle text-med text-mob-smer mb30 mob-mb20">
                    Благодарим Вас за выбор <nobr>ООО «МАКС-Жизнь»</nobr> для заключения договора страхования рисков заемщиков ОТП Банка и предлагаем Вам снизить финансовую нагрузку, вернув
                    <b class="text-red">30%</b> от стоимости оплаченного в банке полиса. <br />Сумма возврата составит <nobr><b>{{ this.obj.data.reduction_amount }}</b> руб.</nobr>
                </div>
                <div v-if="!this.bool.agtAlreadySigned && !this.bool.agtNotFound" class="content__subtitle text-sb text-mid text-mob-sm mb30 mob-mb20">
                    Все остальные условия полиса (страховая сумма, риски, срок страхования и др.) <nobr>&mdash; останутся без изменений.</nobr>
                </div>
                <section v-if="!this.bool.agtNotFound" class="content__section content__section--personal section section--makc">
                    <!-- Для оформления возврата заполните данные Страхователя: -->
                    <h3 class="section__title text-med text-mob-mid mb30 mob-mb20">
                        {{ this.bool.agtAlreadySigned ? "Данные Страхователя:" : "Для оформления возврата заполните данные Страхователя:" }}
                    </h3>
                    <!-- Номер полиса - ФИО -->
                    <div class="inputs inputs--makc mb0">
                        <ul class="inputs__list">
                            <!-- Номер полиса  -->
                            <li class="inputs__item inputs__item--1-of-2 inputs__item--tablet-full" >
                                <div class="clp-input clp-input--makc">
                                    <!-- <label class="clp-input__label" for="policy_number">Номер полиса</label>         -->
                                    <input disabled v-model="this.obj.data.policy_number" class="clp-input__control" type="text" id="policy_number" placeholder="Номер полиса" />
                                    <label v-if="this.arr.errors[0] === 'policy_number' && this.bool.showErrors" class="clp-input__error" for="policy_number" >{{ this.arr.errors[1] }}</label>
                                </div>
                            </li>
                            <li
                                class="inputs__item inputs__item--1-of-2 inputs__item--tablet-hidden"
                            ></li>
                            <!-- Фамилия -->
                            <li
                                class="inputs__item inputs__item--1-of-4 inputs__item--tablet-full"
                            >
                                <div class="clp-input clp-input--makc">
                                    <!-- <label class="clp-input__label" for="surname">Фамилия</label>      -->
                                    <input
                                        disabled
                                        v-model="this.obj.data.surname"
                                        class="clp-input__control"
                                        type="text"
                                        id="surname"
                                        placeholder="Фамилия"
                                    />
                                    <label
                                        v-if="
                                            this.arr.errors[0] === 'surname' &&
                                            this.bool.showErrors
                                        "
                                        class="clp-input__error"
                                        for="surname"
                                        >{{ this.arr.errors[1] }}</label
                                    >
                                </div>
                            </li>
                            <!-- Имя -->
                            <li
                                class="inputs__item inputs__item--1-of-4 inputs__item--tablet-full"
                            >
                                <div class="clp-input clp-input--makc">
                                    <!-- <label class="clp-input__label" for="name">Имя</label>         -->
                                    <input
                                        disabled
                                        v-model="this.obj.data.name"
                                        class="clp-input__control"
                                        type="text"
                                        id="name"
                                        placeholder="Имя"
                                    />
                                    <label
                                        v-if="
                                            this.arr.errors[0] === 'name' &&
                                            this.bool.showErrors
                                        "
                                        class="clp-input__error"
                                        for="name"
                                        >{{ this.arr.errors[1] }}</label
                                    >
                                </div>
                            </li>
                            <!-- Отчество (при наличии) -->
                            <li
                                class="inputs__item inputs__item--1-of-4 inputs__item--tablet-full"
                            >
                                <div class="clp-input clp-input--makc">
                                    <!-- <label class="clp-input__label" for="patronymic">Отчество (при наличии)</label>          -->
                                    <input
                                        disabled
                                        v-model="this.obj.data.patronymic"
                                        class="clp-input__control"
                                        type="text"
                                        id="patronymic"
                                        placeholder="Отчество (при наличии)"
                                    />
                                    <label
                                        v-if="
                                            this.arr.errors[0] ===
                                                'patronymic' &&
                                            this.bool.showErrors
                                        "
                                        class="clp-input__error"
                                        for="patronymic"
                                        >{{ this.arr.errors[1] }}</label
                                    >
                                </div>
                            </li>
                        </ul>
                    </div>
                    <!-- Телефон -->
                    <div class="inputs inputs--makc mb0">
                        <ul class="inputs__list mb0">
                            <li
                                class="inputs__item inputs__item--1-of-3 inputs__item--tablet-full"
                            >
                                <div class="clp-input clp-input--makc">
                                    <!-- <label class="clp-input__label" for="phone">Телефон</label>                                 -->
                                    <input
                                        disabled
                                        v-model="this.obj.data.phone"
                                        class="clp-input__control"
                                        type="text"
                                        id="phone"
                                        placeholder="Телефон"
                                    />
                                    <label
                                        v-if="
                                            this.arr.errors[0] === 'phone' &&
                                            this.bool.showErrors
                                        "
                                        class="clp-input__error"
                                        for="phone"
                                        >{{ this.arr.errors[1] }}</label
                                    >
                                </div>
                            </li>
                        </ul>
                    </div>
                    <div
                        v-if="!this.bool.agtAlreadySigned"
                        class="section__subtitle text-sb text-sm text-mob-tiny mb30 mob-mb20"
                    >
                        На указанный номер телефона будет направлено СМС для
                        подтверждения Вашего согласия на снижение стоимости
                        страхования.
                    </div>
                    <!-- Электронная почта -->
                    <div class="inputs inputs--makc mb10">
                        <ul class="inputs__list mb0">
                            <li
                                class="inputs__item inputs__item--1-of-3 inputs__item--tablet-full"
                            >
                                <div class="clp-input clp-input--makc">
                                    <label
                                        class="clp-input__label clp-input__label--required"
                                        for="email"
                                        >Электронная почта</label
                                    >
                                    <input
                                        :disabled="this.bool.agtAlreadySigned"
                                        v-model="this.obj.data.email"
                                        class="clp-input__control"
                                        type="email"
                                        id="email"
                                        placeholder="Электронная почта"
                                    />
                                    <label
                                        v-if="
                                            this.arr.errors[0] === 'email' &&
                                            this.bool.showErrors
                                        "
                                        class="clp-input__error"
                                        for="email"
                                        >{{ this.arr.errors[1] }}</label
                                    >
                                    <label
                                        v-if="this.arr.errors[0] !== 'email' && !this.bool.agtAlreadySigned"
                                        class="clp-input__error"
                                        for="email"
                                        >обязательное поле</label
                                    >
                                </div>
                            </li>
                        </ul>
                    </div>
                    <div
                        v-if="!this.bool.agtAlreadySigned"
                        class="section__subtitle text-sb text-sm text-mob-tiny mb30 mob-mb20"
                    >
                        На указанную электронную почту Вам будет направлено
                        дополнительное соглашение о снижении стоимости
                        страхования и возврате ее части.
                    </div>
                    <!-- Банковские реквизиты -->
                    <div class="wrapper--bordered">
                        <h3
                            class="section__title text-med text-mob-mid mb30 mob-mb20"
                        >
                            Банковские реквизиты
                        </h3>
                        <div class="inputs inputs--makc mb10">
                            <ul class="inputs__list">
                                <!-- БИК  9 цифр  -->
                                <li
                                    class="inputs__item inputs__item--1-of-2 inputs__item--tablet-full"
                                >
                                    <third-complete
                                        v-model="this.obj.data.bik"
                                        :options="this.optionsBik"
                                        :type="
                                            this.bool.agtAlreadySigned
                                                ? 'disabled'
                                                : 'required'
                                        "
                                        page="req"
                                        placeholder="БИК"
                                        label="БИК"
                                        @updateItem="
                                            ($event) => {
                                                (this.obj.data.bank_name =
                                                    $event.NAMEMINI),
                                                    (this.obj.data.correspondent_account =
                                                        $event.KS);
                                            }
                                        "
                                        :show-err="true"
                                        :err-text="
                                            this.arr.errors[0] === 'bik' &&
                                            this.bool.showErrors
                                                ? this.arr.errors[1]
                                                : !this.bool.agtAlreadySigned ? 'обязательное поле' : ''
                                        "
                                    />
                                </li>
                                <!-- Наименование банка -->
                                <li
                                    class="inputs__item inputs__item--1-of-2 inputs__item--tablet-full"
                                >
                                    <div class="clp-input clp-input--makc">
                                        <!-- <label class="clp-input__label" for="bank_name">Наименование банка</label>         -->
                                        <input
                                            disabled
                                            v-model="this.obj.data.bank_name"
                                            class="clp-input__control"
                                            type="text"
                                            id="bank_name"
                                            placeholder="Наименование банка"
                                        />
                                        <label
                                            v-if="
                                                this.arr.errors[0] ===
                                                    'bank_name' &&
                                                this.bool.showErrors
                                            "
                                            class="clp-input__error"
                                            for="bank_name"
                                            >{{ this.arr.errors[1] }}</label
                                        >
                                    </div>
                                </li>
                                <!-- Номер расчетного счета 20 цифр -->
                                <li
                                    class="inputs__item inputs__item--1-of-2 inputs__item--tablet-full"
                                >
                                    <div class="clp-input clp-input--makc">
                                        <label
                                            class="clp-input__label clp-input__label--required"
                                            for="settlement_account"
                                            >Номер расчетного счета</label
                                        >
                                        <input
                                            :disabled="
                                                this.bool.agtAlreadySigned
                                            "
                                            v-model="
                                                this.obj.data.settlement_account
                                            "
                                            class="clp-input__control"
                                            type="text"
                                            id="settlement_account"
                                            placeholder="Номер расчетного счета"
                                            v-mask="{
                                                mask: '#####-#####-#####-#####',
                                                tokens: {
                                                    '#': { pattern: /\d/ },
                                                },
                                            }"
                                        />
                                        <label v-if="
                                                this.arr.errors[0] ===
                                                    'settlement_account' &&
                                                this.bool.showErrors
                                            "
                                            class="clp-input__error"
                                            for="settlement_account"
                                        >
                                            {{ this.arr.errors[1] }}
                                        </label>
                                        <label
                                            v-if="this.arr.errors[0] !== 'settlement_account' && !this.bool.agtAlreadySigned"
                                            class="clp-input__error"
                                            for="settlement_account"
                                            >обязательное поле</label
                                        >
                                    </div>
                                </li>
                                <!-- Номер корреспондентского счета -->
                                <li
                                    class="inputs__item inputs__item--1-of-2 inputs__item--tablet-full"
                                >
                                    <div class="clp-input clp-input--makc">
                                        <!-- <label class="clp-input__label" for="correspondent_account">Номер корреспондентского счета</label>      -->
                                        <input
                                            disabled
                                            v-model="
                                                this.obj.data
                                                    .correspondent_account
                                            "
                                            class="clp-input__control"
                                            type="text"
                                            id="correspondent_account"
                                            placeholder="Номер корреспондентского счета"
                                        />
                                        <label
                                            v-if="
                                                this.arr.errors[0] ===
                                                    'correspondent_account' &&
                                                this.bool.showErrors
                                            "
                                            class="clp-input__error"
                                            for="correspondent_account"
                                            >{{ this.arr.errors[1] }}</label
                                        >
                                    </div>
                                </li>
                            </ul>
                        </div>
                        <div
                            v-if="!this.bool.agtAlreadySigned"
                            class="section__subtitle text-sb text-sm text-mob-tiny mb30"
                        >
                            На указанные реквизиты в течение 7 рабочих дней
                            будет произведен возврат части страховой премии.
                        </div>
                    </div>
                    <div v-if="!this.bool.agtAlreadySigned" class="section__checkboxes checkboxes mb0">
                        <ul class="checkboxes__list">
                            <!-- Согласен с заключением дополнительного соглашения -->
                            <li class="checkboxes__item">
                                <div class="checkbox checkbox--makc checkbox--makc-giant" >
                                    <input v-model="this.bool.checkAgt" class="checkbox__input" type="checkbox" name="check_agt" value="check_agt" id="check_agt"/>
                                    <label class="checkbox__label" for="check_agt">
                                        <span class="checkbox__label--icon">
                                            <img class="icon" src="@/create/assets/icons/check.svg"/>
                                        </span>
                                        <span class="checkbox__label--text text-sm">
                                            Вводя код из СМС, я соглашаюсь с подписанием дополнительного соглашения к договору страхования жизни простой электронной подписью.
                                        </span>
                                    </label>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <!-- Подтвердить код - Оформить возврат -->
                    <div v-if="!this.bool.agtAlreadySigned" class="section__buttons section__buttons--create-contract">
                        <button :disabled="!this.bool.checkAgt" @click="confirmData()" class="section__button button button--makc button--makc-blue button--makc-smaller">
                            Оформить возврат
                        </button>
                    </div>
                </section>
            </div>
        </div>
    </div>
</template>
<script>
import ClpDialog from "@/create/components/ClpDialog.vue";
import MakcAlert from "@/create/components/MakcAlert.vue";
import DescrAlert from "@/create/components/DescrAlert.vue";
import ThirdComplete from "@/create/components/ThirdComplete.vue";
import ClpNumbers from "@/create/components/ClpNumbers.vue";
import axios from "axios";
import {localDevelopment, baseURL} from "@/create/composables/const";
export default {
    props: ["id"],
    components: { ClpDialog, MakcAlert, DescrAlert, ThirdComplete, ClpNumbers },
    data() {
        return {
            bool: {
                // showDialog: false,
                // showDialog: true,
                fieldsAreValidated: false,
                showErrors: false,
                showPageContent: true,
                // showPageContent: false,
                blockRequest: false,
                codeCheckSuccess: false,
                checkAgt: false,
                agtAlreadySigned: false,
                agtNotFound: false,
            },
            str: {
                sessionToken: "",
                // dialogType: "server_fail",
                // dialogType: 'sms',
                // dialogType: 'loader',
                // dialogType: 'payment',
                // dialogType: 'success',
                // dialogType: 'descr_error',
                descrErrorText: "",
                smsCode: "",
                msgAlert: "Код отправлен на указанный номер",
                numbers: "",
                slug: "",
            },
            arr: {
                errors: [],
            },
            obj: {
                data: {
                    reduction_amount: "",
                    policy_number: "",
                    name: "",
                    surname: "",
                    patronymic: "",
                    phone: "",
                    email: "",
                    bik: "",
                    settlement_account: "",
                    bank_name: "",
                    correspondent_account: "",
                },
            },
            optionsBik: [],
        };
    },
    methods: {
        // запросы
        async getDataBySlug() {
            if (this.bool.blockRequest) return;
            try {
                this.bool.blockRequest = true;
                console.log("getDataBySlug request");
                let request = {
                    action: "get_policy_data",
                    format: "json",
                    object: "statement",
                    login: "sravni",
                    slug: this.str.slug,
                };
                // slug: '71f93f5e-87f3-4e53-89c5-010e7079bc8e', // SUCCESS
                // slug: 'd5506887-6d18-4c7d-eeaf-1aa406f47533', // ERROR
                // slug: '9802c975-a3d3-4cc6-a746-ad278057655c', // EXISTING

                const response = await axios.post(baseURL, request);

                // const r_data = JSON.parse(response.data);
                const r_data = response.data;
                console.log("r_data");
                console.log(r_data);

                if (!r_data) {
                    this.openDialog();
                    console.log("backend error after getDataBySlug request");
                    return;
                }

                this.obj.data.reduction_amount = r_data.amount;
                this.obj.data.policy_number = r_data.policy;
                this.obj.data.name = r_data.first_name;
                this.obj.data.surname = r_data.last_name;
                this.obj.data.patronymic = r_data.middle_name;
                this.obj.data.phone = r_data.phone;

                this.obj.data.email = r_data.email;
                this.obj.data.bik = r_data.bic;
                this.obj.data.settlement_account = r_data.rs;
                this.obj.data.bank_name = r_data.NAMEMINI;
                this.obj.data.correspondent_account = r_data.KS;

                if (r_data.error_code == 9007 || r_data.error_code == 9008) {
                    this.bool.agtAlreadySigned = true;
                } else 
                if (r_data.error_code == 9005) {
                    this.bool.agtNotFound = true;
                } else 
                if (r_data.error_code) {
                    this.openDialog('descr_error');

                    const message = r_data.error_desc;
                    this.str.descrErrorText = message;
                    this.bool.showPageContent = false;
                    
                    console.log("backend error after getDataBySlug request");
                    console.log(r_data.error_desc);
                } else 
                if (r_data.error.message) {
                    this.openDialog('descr_error');

                    const message = r_data.error.log_number;
                    this.str.descrErrorText = message;
                    this.bool.showPageContent = false;
                    
                    console.log("backend error after getDataBySlug request");
                    console.log(r_data.error_desc);
                } 
            } catch (e) {
                console.log("Frontend Error - " + e);
            } finally {
                setTimeout(() => {
                    this.bool.blockRequest = false;
                }, 2000);
            }
        },
        async getBik(val) {
            // if (this.bool.blockRequest) return
            try {
                // this.bool.blockRequest = true;
                console.log("getBik request");
                let request = {
                    action: "ac_bank_by_bic",
                    format: "json",
                    object: "statement",
                    login: "sravni",
                    bank_bik_part: val,
                };

                const response = await axios.post(baseURL, request);
                const r_data = response.data;

                if (r_data.state === "success" && r_data.result.length > 0) {
                    this.optionsBik = r_data.result;
                }
            } catch (e) {
                console.log("Frontend Error - " + e);
            } finally {
                this.bool.blockRequest = false;
            }
        },
        async fetchCode(from = "notButton") {
            if (this.bool.blockRequest) return;
            try {
                this.bool.blockRequest = true;
                console.log("fetchCode request");
                let account = this.obj.data.settlement_account
                    .split("")
                    .filter((item) => item !== "-")
                    .join("");

                let request = {
                    action: "send_reducing_premium_statement_sms",
                    format: "json",
                    object: "statement",
                    login: "sravni",
                    slug: this.str.slug,
                    email: this.obj.data.email,
                    bic: this.obj.data.bik,
                    payment_account: account,
                    agree: "1",
                };
                // slug: '71f93f5e-87f3-4e53-89c5-010e7079bc8e', // SUCCESS
                // slug: 'd5506887-6d18-4c7d-eeaf-1aa406f47533', // ERROR
                // slug: '9802c975-a3d3-4cc6-a746-ad278057655c', // EXISTING

                const response = await axios.post(baseURL, request);

                const r_data = response.data;
                console.log(r_data);

                if (r_data.error_code == 9007 || r_data.error_code == 9008) {
                    this.bool.agtAlreadySigned = true;
                }

                if (from === "button") {
                    if (r_data.state === "success") {
                        this.openDialog('sms');

                        this.str.msgAlert = "Код отправлен на указанный номер";
                    } else if (r_data.state === "error") {
                        this.bool.showErrors = true;

                        // 044525225
                        // 40817-81013-80470-62409
                        if (
                            r_data.error_code == 9018 ||
                            r_data.error_code == 9021 ||
                            r_data.error_code == 9022 ||
                            r_data.error_code == 9023 ||
                            r_data.error_code == 9024
                        ) {
                            this.arr.errors.push("settlement_account");
                            this.arr.errors.push(r_data.error_desc);
                        } else 
                        if (
                            r_data.error_code == 9001 ||
                            r_data.error_code == 9002 ||
                            r_data.error_code == 9003 ||
                            r_data.error_code == 9017
                        ) {
                            this.arr.errors.push("bik");
                            this.arr.errors.push(r_data.error_desc);
                        } else 
                        if (
                            r_data.error_code == 9016 ||
                            r_data.error_code == 9019
                        ) {
                            this.arr.errors.push("email");
                            this.arr.errors.push(r_data.error_desc);
                        } else 
                        if (r_data.error_code){
                            this.openDialog('descr_error');
                            const message = r_data.error_desc;
                            // this.str.descrErrorText = message[0].toUpperCase+message.slice(1, (message.length));
                            this.str.descrErrorText = message;
                            this.bool.showPageContent = false;                            
                            
                            console.log("backend error after fetchCode request");
                            console.log(r_data.error_desc);
                        } else 
                        if (r_data.error.message) {
                            this.openDialog('descr_error');

                            const message = r_data.error.log_number;
                            // this.str.descrErrorText = message[0].toUpperCase+message.slice(1, (message.length));
                            this.str.descrErrorText = message;
                            this.bool.showPageContent = false;
                            
                            console.log("backend error after getDataBySlug request");
                            console.log(r_data.error_desc);
                        }
                    }
                } else if (from !== "button") {
                    this.str.msgAlert =
                        r_data.msg === "Введите код из SMS"
                            ? "Код отправлен на указанный номер"
                            : r_data.msg;
                }
            } catch (e) {
                console.log("Frontend Error - " + e);
            } finally {
                this.bool.blockRequest = false;
            }
        },
        async checkNumbers() {
            try {
                this.bool.codeCheckSuccess = false;
                this.str.msgAlert = "";
                console.log("checkNumbers request by " + this.str.numbers);

                let account = this.obj.data.settlement_account
                    .split("")
                    .filter((item) => item !== "-")
                    .join("");

                const request = {
                    action: "accept_reducing_premium_statement",
                    format: "json",
                    object: "statement",
                    login: "sravni",
                    slug: this.str.slug,
                    email: this.obj.data.email,
                    bic: this.obj.data.bik,
                    payment_account: account,
                    code: this.str.numbers,
                };
                // slug: '71f93f5e-87f3-4e53-89c5-010e7079bc8e', // SUCCESS
                const response = await axios.post(baseURL, request);
                const r_data = response.data;
                console.log(r_data);

                if (r_data.state === "success") {
                    this.str.dialogType = "success";
                } else 
                if (r_data.state === "error" && !r_data.error.message) {
                    this.str.msgAlert = "Введен неверный код";
                } else 
                if (r_data.error.message) {
                    this.openDialog('descr_error');

                    const message = r_data.error.log_number;
                    // this.str.descrErrorText = message[0].toUpperCase+message.slice(1, (message.length));
                    this.str.descrErrorText = message;
                    this.bool.showPageContent = false;

                    console.log("backend error after getDataBySlug request");
                    console.log(r_data.error_desc);
                }
            } catch (e) {
                console.log("Frontend Error - " + e);
            } finally {
            }
        },
        // валидация
        frontValidate() {
            this.arr.errors = [];
            const cyrillicAndNums =
                /^[\u0400-\u04FF\s'\.,-\/#!$%\^&\*;:{}=\-_`~()\d]+$/;
            const cyrillic = /^[\u0400-\u04FF\s'\.,-\/#!$%\^&\*;:{}=\-_`~()]+$/;
            const latin = /^[A-z\u00C0-\u00ff\s'\.,-\/#!$%\^&\*;:{}=\-_`~()]+$/;
            const email = /^[a-zA-Z0-9._-]+@[a-zA-Z_-]+?\.[a-zA-Z]{2,3}$/;
            // данные Страхователя
            if (true) {
                if (false) {
                    return false;
                }
                // // Номер полиса
                // else if (!this.obj.data.policy_number)
                // {
                //     this.arr.errors.push('policy_number');
                //     this.arr.errors.push('укажите номер полиса');
                //     return false
                // }
                // // Фамилия
                // else if (!this.obj.data.surname)
                // {
                //     this.arr.errors.push('surname');
                //     this.arr.errors.push('укажите фамилию');
                //     return false
                // }
                // else if (!cyrillic.test(this.obj.data.surname))
                // {
                //     this.arr.errors.push('surname');
                //     this.arr.errors.push('допустимы только символы кириллицы');
                //     return false
                // }
                // // else if (this.obj.data.surname.length < 3)
                // // {
                // //     this.arr.errors.push('surname');
                // //     this.arr.errors.push('укажите как минимум три буквы');
                // //     return false
                // // }
                // // Имя
                // else if (!this.obj.data.name)
                // {
                //     this.arr.errors.push('name');
                //     this.arr.errors.push('укажите имя');
                //     return false
                // }
                // else if (!cyrillic.test(this.obj.data.name))
                // {
                //     this.arr.errors.push('name');
                //     this.arr.errors.push('допустимы только символы кириллицы');
                //     return false
                // }
                // // else if (this.obj.data.name.length < 3)
                // // {
                // //     this.arr.errors.push('name');
                // //     this.arr.errors.push('укажите как минимум три буквы');
                // //     return false
                // // }
                // else if (this.obj.data.name && this.obj.data.name === this.obj.data.surname)
                // {
                //     this.arr.errors.push('name');
                //     this.arr.errors.push('одинаковые имя и фамилия недопустимы');
                //     return false
                // }
                // // Отчество
                // else if (this.obj.data.patronymic && this.obj.data.patronymic === this.obj.data.surname)
                // {
                //     this.arr.errors.push('patronymic');
                //     this.arr.errors.push('одинаковые отчество и фамилия недопустимы');
                //     return false
                // }
                // else if (this.obj.data.patronymic && this.obj.data.patronymic === this.obj.data.name)
                // {
                //     this.arr.errors.push('patronymic');
                //     this.arr.errors.push('одинаковые имя и отчество недопустимы');
                //     return false
                // }
                // else if (this.obj.data.patronymic && !cyrillic.test(this.obj.data.patronymic))
                // {
                //     this.arr.errors.push('patronymic');
                //     this.arr.errors.push('допустимы только символы кириллицы');
                //     return false
                // }
                // else if (this.obj.data.patronymic && this.obj.data.patronymic.length < 3)
                // {
                //     this.arr.errors.push('patronymic');
                //     this.arr.errors.push('укажите как минимум три буквы');
                //     return false
                // }
                // // Телефон
                // else if (!this.obj.data.phone)
                // {
                //     this.arr.errors.push('phone');
                //     this.arr.errors.push('укажите номер телефона');
                //     return false
                // }
                // else if (this.obj.data.phone.length < 18)
                // {
                //     this.arr.errors.push('phone');
                //     this.arr.errors.push('укажите номер телефона полностью');
                //     return false
                // }
                // Электронная почта
                else if (!this.obj.data.email) {
                    this.arr.errors.push("email");
                    this.arr.errors.push("укажите адрес электронной почты");
                    return false;
                } else if (!email.test(this.obj.data.email)) {
                    this.arr.errors.push("email");
                    this.arr.errors.push(
                        "укажите корректный адрес электронной почты"
                    );
                    return false;
                }
            }
            // Банковские реквизиты
            if (true) {
                if (false) {
                    return false;
                }
                // БИК
                else if (!this.obj.data.bik) {
                    this.arr.errors.push("bik");
                    this.arr.errors.push("укажите БИК");
                    return false;
                } else if (this.obj.data.bik.length < 9) {
                    this.arr.errors.push("bik");
                    this.arr.errors.push("укажите БИК полностью");
                    return false;
                }
                // Номер расчетного счета
                else if (!this.obj.data.settlement_account) {
                    this.arr.errors.push("settlement_account");
                    this.arr.errors.push("укажите номер расчетного счета");
                    return false;
                } else if (this.obj.data.settlement_account.length < 23) {
                    this.arr.errors.push("settlement_account");
                    this.arr.errors.push(
                        "укажите номер расчетного счета полностью"
                    );
                    return false;
                }
            }
            return true;
        },
        // действия и ошибки
        openDialog(type = "server_fail") {
            this.str.dialogType = type;
            this.bool.showDialog = true;
        },
        closeDialog() {
            this.bool.showDialog = false;
        },
        confirmData() {
            if (!this.frontValidate()) {
                this.bool.showErrors = true;
                return;
            }

            this.fetchCode("button");
        },
        clickInputs() {
            this.numbers.input1 =
                this.numbers.input2 =
                this.numbers.input3 =
                this.numbers.input4 =
                    "";
            this.$refs.input1.focus();
        },
        sendAgain() {
            this.sendAgainLink = false;
            this.str.msgAlert = "";

            this.fetchCode();

            this.numbers.input1 =
                this.numbers.input2 =
                this.numbers.input3 =
                this.numbers.input4 =
                    "";

            this.sendAgainLink = true;
        },
    },
    watch: {
        validatedFields: {
            handler(val) {
                this.bool.fieldsAreValidated = this.frontValidate()
                    ? true
                    : false;
            },
            deep: true,
        },
        queryBik(val) {
            this.optionsBik = [];
            if (val === "") return;

            // if (val.length < 3) {
            // this.arr.errors.push('bik');
            // this.arr.errors.push('укажите от 3-х цифр');
            // }

            if (val.length > 2) {
                this.getBik(val);
            }
        },
    },
    computed: {
        validatedFields() {
            const fieldsToValidate = {
                personal: JSON.parse(JSON.stringify(this.obj.data)),
                reqs: JSON.parse(JSON.stringify(this.obj.data)),
            };
            return fieldsToValidate;
        },
        queryBik() {
            return this.obj.data.bik;
        },
    },
    mounted() {
        window.document.head.getElementsByTagName("title")[0].innerHTML =
            "Реквизиты";
        this.str.sessionToken = new Date();
        this.str.slug = window.location.href.split("/").pop().split("?")[0];

        this.getDataBySlug();
    },
};
</script>

<style scoped lang="scss"></style>
